import type { UseSearchQuoteItemsParams } from './types';

export type UseSearchQuoteItemsQueryKey = readonly [
  'search',
  'quoteItems',
  UseSearchQuoteItemsParams,
];

export const getUseSearchQuoteItemsQueryKey = (
  params: UseSearchQuoteItemsParams,
): UseSearchQuoteItemsQueryKey => ['search', 'quoteItems', params];
